import apiClient from 'api/apiClient';

// eslint-disable-next-line import/prefer-default-export
export const getInstitutions = ([institutionNames]) => apiClient.get('/v1/institutions', {
  params: {
    institutionNames,
  },
});
